import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeLike, curveGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {WeldOperatorParameters} from "#template/nodes/geometry-graph/attribute/weld-operator/geometry-weld-operator-node"
import {GeometryWeldOperatorNode, weldOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute/weld-operator/geometry-weld-operator-node"

export type CurveGeometryWeldOperatorParameters = WeldOperatorParameters<CurveGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryWeldOperatorParameters> = {
    nodeClass: "CurveGeometryWeldOperator",
    validation: {
        parameters: weldOperatorParametersSchema(curveGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryWeldOperator extends GeometryWeldOperatorNode<1, CurveGeometryAttributeLikeNode> implements CurveGeometryAttributeLikeNode {
    get [curveGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
